import moengage from "@moengage/web-sdk";

class MoEngageConnector {

	constructor() {
		this.emailtoCheck = "";
		this.previousUser = "";
		this.loginPromiseReturn;
		this.moEngageInit = false;
	}

	init(){
		this.moEngageData = window.__MOENGAGE_DATA__?.moEngageData;
		this.userData = window.__MOENGAGE_DATA__?.userData;
		this.events = window.__MOENGAGE_DATA__?.events;

		this.__moengageInitialise()
    }

	__initLogin = e => {
		this.emailtoCheck = e.toLowerCase();
		if (moEngageVar.moEngageInit){
			moEngageVar.__userLogin();
		} else {
			this.init()
		}
		return new Promise((resolve)=> {
			this.loginPromiseReturn = resolve;
		})
	}

	__moengageInitialise = () => {
		// console.log('moengageInitialising')
		moengage.initialize(
			{
				app_id: this.moEngageData['appID'],
				cluster: this.moEngageData['cluster'],
				debug_logs: this.moEngageData['debug']
			}
		)

		window.addEventListener("MOE_LIFECYCLE",function(e) {
			if (e.detail.name === "SETTINGS_FETCHED") {
				// console.log(e.detail.data)
				moEngageVar.moEngageInit = true;
				moEngageVar.__userLogin();
			}
		})

		if (this.events) {
			this.__sendEvents()
		}
	}

	__userLogin() {
		if (this.emailtoCheck !== "") {
			this.userData = {"email": this.emailtoCheck};
		}
		if (moEngageVar.userData) {
			moEngageVar.__userDataCheck().then(
					function (resolve) {
						moEngageVar.__userUpdate(moEngageVar.previousUser);
					}
			)
		}
	}

	__userDataCheck() {

		return new Promise((resolve) => {
			let previousUser = Moengage.user.getAttributes();
			// console.log('comparingEmails', previousUser.USER_ATTRIBUTE_UNIQUE_ID, moEngageVar.userData['email'])
			this.previousUser = previousUser.USER_ATTRIBUTE_UNIQUE_ID;
			resolve();
		});
	}

	__userUpdate = (previousUser) => {
		if (previousUser == null) {
			// console.log('Previous User Null')
			moengage.update_unique_user_id(this.userData['email']);
			this.__resolvePromise();
		} else if (previousUser !== this.userData['email']) {
			// console.log('Different Email Detected: Destroy')
			moengage.destroy_session().then(() => {
				moengage.update_unique_user_id(this.userData['email'])
			})
		} else if (previousUser === this.userData['email']) {
			// console.log('Same Email')
			this.__resolvePromise();
		}
	}

	__sendEvents = () => {

		for (let eventName in this.events) {
			moengage.track_event(eventName, this.events[eventName])
		}
	}

	__resolvePromise = () => {
		if (moEngageVar.loginPromiseReturn) {
			moEngageVar.loginPromiseReturn(true);
		}
	}
}

export default MoEngageConnector